import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Row, Col } from "react-bootstrap";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import { updatedSideOrBottmeAppMenu } from "BrandingAction";
import { updateUnsavedChanges } from "DashboardMenuAction";
import {
  updateSortedFeatures,
  updateBottomMenuLocally,
  updateAppSideMenuLocally,
} from "GeneralTabAction";
import { fetchSettings } from "TicketAction";
import { changeAppBottomMenuStatus } from "SettingActions";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
import NewContentFeatureItem from "NewContentFeatureItem";
import LocaleStrings from "Languages";
import { toggleEditAppBottomMenuEditor } from "../actions/branding-actions";
import EditAppBottomMenu from "./editAppBottomMenu";
import AppIcons from "AppIcons";

const menuSize = 5;
const appBottomMenuExtra = [
  {
    iconName: "Scanner",
    displayname: "Scanner",
    available: false,
    bsClass: "scanner",
    description: "Scan QR code",
  },
  {
    iconName: "Home",
    displayname: "Home",
    available: true,
    bsClass: "home",
    description: "Welcome to Home",
  },
];

// used for sort content list
const SortableItem = SortableElement(({ value, sortIndex }) => (
  <NewContentFeatureItem feature={value} />
));

const SortableList = SortableContainer(({ items }) => {
  return (
    <ul className="list-group">
      {items.map((value, index) => {
        if (
          value.isenabled &&
          value.taborder !== 99 &&
          value.bsClass !== "message"
          //  && value.bsClass !== "about"
        ) {
          return (
            <SortableItem
              key={`item-${value.apptabid}`}
              index={index}
              value={value}
            />
          );
        }
      })}
    </ul>
  );
});

class AppBottomMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updated: false,
      optionsArray: new Array(),
      defaultOptions: [],
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.getDefaultOptions();
      this.setOptionsArray();
    }, 100);
  }

  submitBrandingData = () => {
    var {
      mergerArray,
      appMenu,
      isUpdatedSideBottomAppMenu,
      submitBrandingDataHandler,
    } = this.props;
    var array = {
      source: "appmenu",
      sidemenu: mergerArray,
      bottommenu: appMenu,
      updatedmenu: isUpdatedSideBottomAppMenu,
    };

    submitBrandingDataHandler(array);
  };

  getDefaultOptions() {
    let { mergerArray, appMenu, userModule } = this.props;
    let { optionsArray } = this.state;

    _.map(appMenu, (sel, i) => {
      // this loop is used only to create a multidimentional array(optionsArray)

      var options =
        i > 1
          ? [
              {
                label: "Disable",
                value: "disable",
              },
            ]
          : [];

      if (userModule[0].isenabled) {
        options.push({
          label: appBottomMenuExtra[0].iconName,
          value: appBottomMenuExtra[0].bsClass,
        });
      }

      options.push({
        label: appBottomMenuExtra[1].iconName,
        value: appBottomMenuExtra[1].bsClass,
      });

      _.map(mergerArray, (opt) => {
        if (opt.isenabled == true) {
          if (opt.bsClass == "polls") {
            options = _.concat(options, { label: "Polls", value: "polls" });
          } else {
            options = _.concat(options, {
              label: opt.iconName,
              value: opt.bsClass.toLowerCase(),
            });
          }
        }
      });
      optionsArray.splice(i, 1, { options: options, isenabled: sel.isenabled });
    });
    this.setState({
      optionsArray,
      defaultOptions: optionsArray.length > 0 ? optionsArray[0].options : [],
    });
  }

  setOptionsArray() {
    let { appMenu } = this.props;
    let { optionsArray } = this.state;

    for (let i = 0; i < appMenu.length; i++) {
      let item = appMenu[i].iconName;

      if (item) {
        for (let j = 0; j < appMenu.length; j++) {
          if (i == j) {
            optionsArray.splice(j, 1, {
              options: optionsArray[j].options,
              isenabled: appMenu[j].isenabled,
            });
          } else {
            _.remove(optionsArray[j].options, function (obj) {
              return obj.label == item;
            });
            optionsArray.splice(j, 1, {
              options: optionsArray[j].options,
              isenabled: appMenu[j].isenabled,
            });
          }
        }
      }
    }
    this.setState({ optionsArray });
  }

  optionSelect = (e, i) => {
    var newKey = e;
    var appBottomExtra = appBottomMenuExtra;
    var { mergerArray, appMenu, appBtmMenuFixed, isUpdatedSideBottomAppMenu } =
      this.props;
    var bottomMenu = appMenu.slice();
    var newSelected = [];
    var menu = {};

    if (newKey === "home" || newKey === "scanner") {
      newSelected = _.filter(appBottomExtra, (obj) => {
        return obj.bsClass === newKey;
      });
    } else {
      newSelected = _.filter(mergerArray, (obj) => {
        return obj.bsClass === newKey;
      });
    }
    if (i > 1 && newKey === "disable") {
      bottomMenu[i].isenabled = false;
    } else {
      var checkExisting = _.filter(appBtmMenuFixed, (obj) => {
        return obj.tabslected === `btm-${newKey}`;
      });
      if (checkExisting.length > 0) {
        newSelected = checkExisting;
      }

      bottomMenu[i].tabslected = `btm-${newSelected[0].bsClass}`;
      bottomMenu[i].iconName = newSelected[0].iconName;
      bottomMenu[i].displaytabname = newSelected[0].displaytabname
        ? newSelected[0].displaytabname
        : newSelected[0].displayname;
      bottomMenu[i].bsClass = newSelected[0].bsClass;
      bottomMenu[i].isenabled = true;
    }

    this.props.updateUnsavedChanges(true);
    this.props.updateBottomMenuLocally(bottomMenu);

    menu = { sidemenu: isUpdatedSideBottomAppMenu.sidemenu, bottommenu: true }; // this is used to handle bottom menu updated
    this.props.updatedSideOrBottmeAppMenu(menu);

    this.getDefaultOptions();
    this.setOptionsArray();
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    var { isUpdatedSideBottomAppMenu } = this.props;
    var menu = {};
    var arrAvailable = _.filter(this.props.mergerArray, (obj) => {
      return obj.taborder !== 99;
    });
    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);
    var newArrAvailable = [];
    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, taborder: index + 1 });
    });

    this.props.updateUnsavedChanges(true);
    this.props.updateAppSideMenuLocally(newArrAvailable);

    menu = {
      sidemenu: true,
      bottommenu: isUpdatedSideBottomAppMenu.bottommenu,
    }; // this is used to handle bottom menu updated

    this.props.updatedSideOrBottmeAppMenu(menu);
    // this.props.updateSortedFeatures(newArrAvailable, this.props.session);
  };

  handleAppBottomMenu = () => {
    var { session, settingData, isUpdatedSideBottomAppMenu } = this.props;
    let option = 0;
    let message = LocaleStrings.basic_setting_alert_app_bottom_menu_deactivated;
    if (settingData && settingData.isbottommenuactive == false) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_app_bottom_menu_activated;
    }

    this.props.changeAppBottomMenuStatus(
      session,
      option,
      settingData.id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.props.showSuccess(message);
          });
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  onClickEditName = (e, pos, value) => {
    this.props.toggleEditAppBottomMenuEditor({
      show: true,
      position: pos,
      value: value,
    });
  };

  renderBottomMenus = () => {
    let { appMenu } = this.props;
    var { optionsArray } = this.state;
    var returnArray = [];
    var colstyle = { padding: 0, textAlign: "center" };
    var btnstyle = { minWidth: 82, width: 82 };

    _.map(appMenu, (menu, i) => {
      var icon = `../../style/images/content-icons/content-${menu.bsClass}-Selected.png`;
      var blankicon = `../../style/images/icons/not-selected.png`;
      returnArray.push(
        menu.isenabled ? (
          <Col md={8} key={`key_${i}`} style={colstyle}>
            <div
              className={`content-appbtn-menu`}
              style={
                menu.bsClass === "" ? { backgroundColor: "#cccccc66" } : {}
              }
            >
              <div className="content-aapbtn-icon">
                {/* <img src={icon} style={{ height: "40px" }} /> */}
                <div className={`custom-icons-theme`}>
                  {menu.bsClass === "gamification"
                    ? AppIcons[`content_${menu.bsClass}`]
                    : AppIcons[menu.bsClass]}
                </div>
              </div>

              <div className="content-aapbtn-display">
                {menu.bsClass === "" ? (
                  ""
                ) : (
                  <DropdownButton
                    className="content-aapbtn-button"
                    title={`${
                      menu.bsClass === "polls" ? "Polls" : menu.iconName
                    }`}
                    key="1"
                    id="dropdown-basic-1"
                    bsSize="xsmall"
                    nocaret="true"
                    // style={btnstyle}
                  >
                    {_.map(optionsArray[i].options, (opt) => {
                      return (
                        <Dropdown.Item
                          key={`${opt.value}_${i}`}
                          eventKey={opt.value}
                          onClick={(e) => this.optionSelect(opt.value, i)}
                        >
                          {opt.label}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                )}
                {/* <div style={{fontSize: 12, paddingTop: 5}}>{menu.bsClass === 'polls' ? 'Polls' : menu.iconName}</div> */}
              </div>
            </div>
          </Col>
        ) : (
          <Col md={8} key={`key_${i}`} style={colstyle}>
            <div
              className={`content-appbtn-menu`}
              style={
                menu.bsClass === "" ? { backgroundColor: "#cccccc66" } : {}
              }
            >
              <div className="content-aapbtn-icon">
                {/* <img src={icon} style={{ height: "40px" }} /> */}
                <div className={`custom-icons-theme`}>
                  {AppIcons[`circle_questionmark`]}
                </div>
              </div>
              <div className="content-aapbtn-display">
                <DropdownButton
                  className="content-aapbtn-button"
                  title="Select"
                  key="1"
                  id="dropdown-basic-1"
                  bsSize="xsmall"
                  nocaret="true"
                  // style={btnstyle}
                >
                  {_.map(optionsArray[i].options, (opt) => {
                    return (
                      <Dropdown.Item
                        key={`${opt.value}_${i}`}
                        eventKey={opt.value}
                        onClick={(e) => this.optionSelect(opt.value, i)}
                      >
                        {opt.label}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </div>
            </div>
          </Col>
        )
      );
    });

    return returnArray;
  };

  renderDisplayTabName = () => {
    let { appMenu } = this.props;
    var returnArray = [];
    var colstyle = { padding: 0 };

    // ================================= Creating edit displaytabname Statically =================================
    var menu = appMenu[0];
    returnArray.push(
      menu.isenabled ? (
        <Col md={12} key={`key_0`} style={colstyle}>
          <div className="" style={{ margin: "0px 0px 20px" }}>
            {menu.bsClass === "" ? (
              <div></div>
            ) : (
              <div className="editable">
                {this.props.toEditAppBottomMenu.show &&
                this.props.toEditAppBottomMenu.position === 0 ? (
                  <EditAppBottomMenu
                    history={this.props.history}
                    tab={menu}
                    btmmenu={appMenu}
                  />
                ) : (
                  <div
                    className="content-subheading-title displaynames vertical-align-center"
                    style={{ height: 40 }}
                  >
                    {menu.displaytabname}
                    {/* {menu.iconName} */}
                    {menu.bsClass ? (
                      <button
                        className="edit-mapname"
                        onClick={(e) =>
                          this.onClickEditName(e, 0, menu.displaytabname)
                        }
                      >
                        <img
                          className="i-custom-normal"
                          src="../../style/images/custom-icons/edit.svg"
                        />
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
      ) : (
        <Col
          md={12}
          className="ban-image"
          key={`key_0`}
          style={{ margin: "0px 0px 20px" }}
        >
          <div
            className="content-aapbtn-icon vertical-align-center"
            style={{ height: 40 }}
          >
            <div className={`custom-icons-theme`}>{AppIcons[`blocked`]}</div>
          </div>
        </Col>
      )
    );

    var menu = appMenu[1];
    returnArray.push(
      menu.isenabled ? (
        <Col md={12} key={`key_1`} style={colstyle}>
          <div className="">
            {menu.bsClass === "" ? (
              <div></div>
            ) : (
              <div className="editable" style={{ margin: "0px 0px 20px" }}>
                {this.props.toEditAppBottomMenu.show &&
                this.props.toEditAppBottomMenu.position === 1 ? (
                  <EditAppBottomMenu
                    history={this.props.history}
                    tab={menu}
                    btmmenu={appMenu}
                  />
                ) : (
                  <div
                    className="content-subheading-title displaynames vertical-align-center"
                    style={{ height: 40 }}
                  >
                    {menu.displaytabname}
                    {/* {menu.iconName} */}
                    {menu.bsClass ? (
                      <button
                        className="edit-mapname"
                        onClick={(e) =>
                          this.onClickEditName(e, 1, menu.displaytabname)
                        }
                      >
                        <img
                          className="i-custom-normal"
                          src="../../style/images/custom-icons/edit.svg"
                        />
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
      ) : (
        <Col
          md={12}
          className="ban-image"
          key={`key_1`}
          style={{ margin: "0px 0px 20px" }}
        >
          <div
            className="content-aapbtn-icon vertical-align-center"
            style={{ height: 40 }}
          >
            <div className={`custom-icons-theme`}>{AppIcons[`blocked`]}</div>
          </div>
        </Col>
      )
    );

    var menu = appMenu[2];
    returnArray.push(
      menu.isenabled ? (
        <Col md={12} key={`key_2`} style={colstyle}>
          <div className="" style={{ padding: 0 }}>
            {menu.bsClass === "" ? (
              <div
                className="scanner-menus"
                style={{ margin: "0px 0px 20px" }}
              ></div>
            ) : (
              <div className="editable" style={{ margin: "0px 0px 20px" }}>
                {this.props.toEditAppBottomMenu.show &&
                this.props.toEditAppBottomMenu.position === 2 ? (
                  <EditAppBottomMenu
                    history={this.props.history}
                    tab={menu}
                    btmmenu={appMenu}
                  />
                ) : (
                  <div
                    className="content-subheading-title displaynames vertical-align-center"
                    style={{ height: 40 }}
                  >
                    {menu.displaytabname}
                    {/* {menu.iconName} */}
                    {menu.bsClass ? (
                      <button
                        className="edit-mapname"
                        onClick={(e) =>
                          this.onClickEditName(e, 2, menu.displaytabname)
                        }
                      >
                        <img
                          className="i-custom-normal"
                          src="../../style/images/custom-icons/edit.svg"
                        />
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
      ) : (
        <Col
          md={12}
          className="ban-image"
          key={`key_2`}
          style={{ margin: "0px 0px 20px" }}
        >
          <div
            className="content-aapbtn-icon vertical-align-center"
            style={{ height: 40 }}
          >
            <div className={`custom-icons-theme`}>{AppIcons[`blocked`]}</div>
          </div>
        </Col>
      )
    );

    var menu = appMenu[3];
    returnArray.push(
      menu.isenabled ? (
        <Col md={12} key={`key_3`} style={colstyle}>
          <div className="">
            {menu.bsClass === "" ? (
              <div></div>
            ) : (
              <div className="editable" style={{ margin: "0px 0px 20px" }}>
                {this.props.toEditAppBottomMenu.show &&
                this.props.toEditAppBottomMenu.position === 3 ? (
                  <EditAppBottomMenu
                    history={this.props.history}
                    tab={menu}
                    btmmenu={appMenu}
                  />
                ) : (
                  <div
                    className="content-subheading-title displaynames vertical-align-center"
                    style={{ height: 40 }}
                  >
                    {menu.displaytabname}
                    {/* {menu.iconName} */}
                    {menu.bsClass ? (
                      <button
                        className="edit-mapname"
                        onClick={(e) =>
                          this.onClickEditName(e, 3, menu.displaytabname)
                        }
                      >
                        <img
                          className="i-custom-normal"
                          src="../../style/images/custom-icons/edit.svg"
                        />
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
      ) : (
        <Col
          md={12}
          className="ban-image"
          key={`key_3`}
          style={{ margin: "0px 0px 20px" }}
        >
          <div
            className="content-aapbtn-icon vertical-align-center"
            style={{ height: 40 }}
          >
            <div className={`custom-icons-theme`}>{AppIcons[`blocked`]}</div>
          </div>
        </Col>
      )
    );

    var menu = appMenu[4];
    returnArray.push(
      menu.isenabled ? (
        <Col md={12} key={`key_4`} style={colstyle}>
          <div className="">
            {menu.bsClass === "" ? (
              <div></div>
            ) : (
              <div className="editable" style={{ margin: "0px 0px 20px" }}>
                {this.props.toEditAppBottomMenu.show &&
                this.props.toEditAppBottomMenu.position === 4 ? (
                  <EditAppBottomMenu
                    history={this.props.history}
                    tab={menu}
                    btmmenu={appMenu}
                  />
                ) : (
                  <div
                    className="content-subheading-title displaynames vertical-align-center"
                    style={{ height: 40 }}
                  >
                    {menu.displaytabname}
                    {/* {menu.iconName} */}
                    {menu.bsClass ? (
                      <button
                        className="edit-mapname"
                        onClick={(e) =>
                          this.onClickEditName(e, 4, menu.displaytabname)
                        }
                      >
                        <img
                          className="i-custom-normal"
                          src="../../style/images/custom-icons/edit.svg"
                        />
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
      ) : (
        <Col
          md={12}
          className="ban-image"
          key={`key_4`}
          style={{ margin: "0px 0px 20px" }}
        >
          <div
            className="content-aapbtn-icon vertical-align-center"
            style={{ height: 40 }}
          >
            <div className={`custom-icons-theme`}>{AppIcons[`blocked`]}</div>
          </div>
        </Col>
      )
    );
    // ================================= END *** Creating edit displaytabname Statically =================================

    return returnArray;
  };

  rendermenunames = () => {
    let { appMenu } = this.props;
    var returnArray = [];

    _.map(appMenu, (menu, i) => {
      var icon = `../../style/images/content-icons/content-${menu.bsClass}-Selected.png`;
      var blankicon = `../../style/images/icons/not-selected.png`;
      returnArray.push(
        menu.isenabled ? (
          <div
            key={`key_${i}`}
            style={
              menu.bsClass === ""
                ? {
                    backgroundColor: "#cccccc66",
                    borderRadius: 20,
                    padding: "2px 8px",
                  }
                : {}
            }
          >
            <div className="content-aapbtn-icon">
              {/* {" "}<img src={icon} style={{ height: "40px" }} />{" "} */}
              <div className={`custom-icons-theme`}>
                {menu.bsClass === "gamification"
                  ? AppIcons[`content_${menu.bsClass}`]
                  : AppIcons[menu.bsClass]}
              </div>
            </div>
          </div>
        ) : (
          // <div key={`key_${i}`}>
          //   <img src={blankicon} style={{ width: 40, height: 40 }} />
          // </div>
          <div key={`key_${i}`} className="content-aapbtn-icon">
            <div className={`custom-icons-secondary`}>
              {AppIcons[`blocked`]}
            </div>
          </div>
        )
      );
    });

    return returnArray;
  };

  render() {
    let { mergerArray, settingData } = this.props;
    var { optionsArray } = this.state;
    let appBottomMenu = false;
    if (settingData && settingData.isbottommenuactive == true) {
      appBottomMenu = true;
    }

    return (
      <Row>
        <Col
          sm={12}
          md={5}
          lg={3}
          style={{ borderRight: "1px solid  #E6EDF3" }}
        >
          <div className="vertical-align-center gap-2">
            <spna className="custom-text1-primary-medium">
              {LocaleStrings.branding_app_side_menu}
            </spna>
            <div className="app-menu-info">
              <img
                className="pointer"
                src="../../style/images/header-icons/infoicon.png"
                alt="info"
              />
              <span className="overlay custom-text2-primary-normal">
                {LocaleStrings.branding_app_side_menu_info}
              </span>
            </div>
          </div>
          <div className="custom-text2-secondary-normal mt-2">
            {LocaleStrings.branding_app_side_menu_subtitle}
          </div>
          <div className="content-submenu-branding">
            <div
              style={{
                backfaceVisibility: "hidden",
                willChange: "transform",
                userSelect: "none",
                WebkitUserSelect: "none",
                titleBarStyle: "hidden",
              }}
            >
              <SortableList
                items={mergerArray.length > 0 ? mergerArray : []}
                onSortEnd={this.onSortEnd}
                //pressDelay={0}
                lockAxis="y"
              />
            </div>
          </div>
        </Col>

        <Col sm={12} md={7} lg={4} style={{ paddingLeft: 25 }}>
          <div>
            <div className="vertical-align-center gap-2">
              <span className="custom-text1-primary-medium">
                {LocaleStrings.branding_app_bottom_menu}
              </span>
              <span className="app-menu-info">
                <img
                  className="pointer"
                  src="../../style/images/header-icons/infoicon.png"
                  alt="info"
                />
                <span className="overlay custom-text2-primary-normal">
                  {LocaleStrings.branding_app_bottom_menu_subtitle}
                </span>
              </span>
            </div>
            <div className="custom-text2-secondary-normal mt-2">
              {LocaleStrings.branding_app_bottom_menu_subtitle}
            </div>

            <label
              className="switch-button-container mt-2"
              style={{ marginLeft: 5 }}
            >
              <input
                type="checkbox"
                onChange={this.handleAppBottomMenu}
                checked={appBottomMenu}
              />
              <span className="switch-slider switch-round"></span>
            </label>
            <div className="bottom-enable-menu-text"></div>
          </div>

          <div className="branding-template-container">
            <img src="../../style/images/v2_icons/branding/branding_placeholder_image.png" />
          </div>

          {optionsArray[0] &&
          settingData &&
          settingData.isbottommenuactive == true ? (
            <div className="bottom-menu-icons">{this.rendermenunames()}</div>
          ) : (
            ""
          )}
        </Col>

        <Col sm={6} md={8} lg={2} className="bottonmenu-listtabs">
          {optionsArray[0] &&
          settingData &&
          settingData.isbottommenuactive == true ? (
            <div
              className="bottom-menutab"
              style={{ display: "block", marginTop: 200 }}
            >
              <Row>{this.renderBottomMenus()}</Row>
            </div>
          ) : (
            ""
          )}
        </Col>
        <Col
          sm={6}
          md={4}
          lg={3}
          className="bottomlast-menutab"
          style={{ paddingLeft: "50px", marginTop: 210 }}
        >
          {optionsArray[0] &&
          settingData &&
          settingData.isbottommenuactive == true ? (
            <div style={{ display: "block", paddingBottom: "30px" }}>
              <Row>{this.renderDisplayTabName()}</Row>
            </div>
          ) : (
            ""
          )}
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  var settinVal = {};
  var userModule = [{ isenabled: true }];

  if (
    state.SettingData &&
    state.SettingData.resource &&
    state.SettingData.resource.length > 0
  ) {
    settinVal = state.SettingData.resource[0];
  }

  if (state.actionAppModules && state.actionAppModules.length > 0) {
    userModule = _.filter(state.actionAppModules, (obj) => {
      return obj.bsClass == "users";
    });
  }

  return {
    session: state.session,
    mergerArray: state.contentDisplayItems,
    appMenu: state.appBottomMenu,
    appBtmMenuFixed: state.appBtmMenuFixed,
    userModule,
    isUpdatedSideBottomAppMenu: state.isUpdatedSideBottomAppMenu,
    settingData: settinVal,
    toEditAppBottomMenu: state.toEditAppBottomMenu,
  };
}

export default connect(
  mapStateToProps,
  {
    updateSortedFeatures,
    updateUnsavedChanges,
    updateBottomMenuLocally,
    updateAppSideMenuLocally,
    updatedSideOrBottmeAppMenu,
    fetchSettings,
    changeAppBottomMenuStatus,
    showError,
    showSuccess,
    toggleEditAppBottomMenuEditor,
  },
  null,
  { forwardRef: true }
)(AppBottomMenu);
